import { Deserializable } from './deserializable';


export class DeviceStateData implements Deserializable {

  serial: string;
  type: string;
  value: number = 0;


  static TYPE_STATE_CYCLES_UP: string = "sta-cyup";
  static TYPE_STATE_CYCLES_DOWN: string = "sta-cydo";
  static TYPE_STATE_CYCLES_EFO: string = "sta-cyefo";
  static TYPE_STATE_INVERSIONS_PRESSURE: string = "sta-invp";
  static TYPE_STATE_INVERSIONS_SAFETY: string = "sta-invs";
  static TYPE_STATE_TIMEOUTS_RISING: string = "sta-tris";
  static TYPE_STATE_TIMEOUTS_LOWERING: string = "sta-tlow";
  static TYPE_STATE_NUM_BOLLARDS: string = "sta-bol";
  static TYPE_STATE_DIP_SWITCH_SERVICE: string = "sta-dip";


  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }



  // isError(): boolean {

  //   return "Error" == this.state;
  // }

}
